import React from 'react';

import { Table, TableHead, TableCell, TableBody, TableRow } from '@material-ui/core';

import { CardComponent } from 'components';
import { TablePaginationComponent } from 'components/TablePaginationComponent/TablePaginationComponent';
import { getTWithPathKey } from 'utils';
import { NotificationItem, PaginationParams } from 'types';

export interface ErrorsLogComponentProps {
  notificationMessages: NotificationItem[];
  count: number;
  paginationParams: PaginationParams;
  onChangePaginationParams: (paginationParams: PaginationParams) => void;
}

export function ErrorsLogComponent({
  notificationMessages,
  count,
  paginationParams,
  onChangePaginationParams,
}: ErrorsLogComponentProps) {
  const getT = getTWithPathKey('pages.ecommerceProvider.notifications');

  return (
    <CardComponent title={getT('header', { count })} xs={9}>
      {notificationMessages.length ? (
        <>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{getT('title')}</TableCell>
                <TableCell>{getT('message')}</TableCell>
                <TableCell>{getT('date')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {notificationMessages.map(message => (
                <TableRow key={`${message.title}${message.body}${message.createdAt}`}>
                  <TableCell>{message.title}</TableCell>
                  <TableCell>{message.body}</TableCell>
                  <TableCell>{message.createdAt}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePaginationComponent
            count={count}
            paginationParams={paginationParams}
            onChangePaginationParams={onChangePaginationParams}
          />
        </>
      ) : null}
    </CardComponent>
  );
}
